export const RECOMMENDATIONS_ACTIONS_KEYS = {
  getRecommendations: 'getRecommendations',
  clearRecommendations: 'clearRecommendations'
} as const;

export const RECOMMENDATIONS_GETTERS_KEYS = {
  infiniteScrollEnabled: 'infiniteScrollEnabled',
  topRecommendations: 'topRecommendations'
};

export const RECOMMENDATIONS_MUTATIONS_KEYS = {
  increasePage: 'increasePage',
  replaceState: 'replaceState',
  saveRecommendations: 'saveRecommendations',
  setInfiniteScrollEnabled: 'setInfiniteScrollEnabled',
  setLastCount: 'setLastCount',
  setLoading: 'setLoading',
  setOrigin: 'setOrigin',
  setPage: 'setPage'
} as const;
